import Model from '@/models/Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default class Job extends Model {
  resource() {
    return 'jobs'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .format('DD/MMM/YYYY')
      .toUpperCase()
  }
}
